import { Card } from 'react-bootstrap';
import { PageCardWrapper } from '../../../../sitel/demon/ui/atoms';
import { FieldValidationErrorMsg, RequiredAsterisk } from '../../../../sitel/demon/ui/atoms/form';
import { useEffect, useState } from 'react';
import { vendorList } from '../../../../services/api';
import MedstarEntitiesDropdown from '../../../../sitel/demon/ui/organisms/formElements/medstarEntitiesDropdown';
import { InputText } from '../../../../sitel/demon/ui/form';

export default function Vendor({ register, errors }) {
  const [vendors, setVendors] = useState([]);
  useEffect(() => {
    vendorList(
      (response) => {
        setVendors(response.data.payload.vendorList);
      },
      (error) => console.error('get vendors api errored out', error)
    );
  }, []);

  return (
    <PageCardWrapper title='Employment Information'>
      <Card.Body>
        <div className='row'>
          {
            vendors.length && (
              <div className='form-group mb-2'>
              <label htmlFor='vendor'>Employer name</label>
              <RequiredAsterisk />
              <select id='vendor' className='form-control' {...register('vendor')}>
                <option value='nope'>Choose...</option>

                {vendors.map((vendorDuplex) => {
                  return (
                    <option key={vendorDuplex.id} value={vendorDuplex.id}>
                      {vendorDuplex.vendor}
                    </option>
                  );
                })}
                <option value='0'>Other...</option>
              </select>
              <FieldValidationErrorMsg field='vendor' errors={errors} />
            </div>
            )
          }
          <div className='col-lg-6'>
            <MedstarEntitiesDropdown register={register} errors={errors} showIsRequired />
          </div>
          <div className='col-lg-6 mb-2'>
            <InputText labelText='MedStar Health department' id='department' placeholder='' showIsRequired maxlength='50' register={register} errors={errors} />
          </div>
          <div className='col-lg-6'>
            <InputText labelText='MedStar Health leader' id='leaderName' placeholder="Enter leader's first and last name" showIsRequired maxlength='100' register={register} errors={errors} />
          </div>
          <div className='col-lg-6'>
            <InputText labelText="Leader's email" id='leaderEmail' placeholder="Enter leader's email: @medstar.net @gunet.georgetown.edu @medstarmontgomery.org" showIsRequired maxlength='100' register={register} errors={errors} />
          </div>
        </div>
      </Card.Body>
    </PageCardWrapper>
  );
}
